<template>
    <AppLayout
        ref="layout"
        page="/dashboard"
        pageTitle="Leads"
        backLink="/dashboard/reports"
        hasFab
        :fabClasses="$page.props.crmClient?.id ? 'leads-fab' : 'leads-fab-hide'"
        @fabAction="manageLead = true"
    >
        <!--<CRMDrawer
            v-if="showCRMDrawer"
            :lead="leads[0]"
            @reset=""
            @success=""
            :errors="errors"
        />-->
        <v-col cols="12" class="pa-1">
            <Stats class="pb-3" :stats="stats" />
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <ReportHeader
                        :subtitle="
                            allLocations
                                ? 'Leads By Location'
                                : `${selectedLocation.name} Leads`
                        "
                        :allLocations="allLocations"
                        locationOptions
                        :selectedLocation="selectedLocation"
                        filter
                        :dateRange="dateRange"
                        reportUrl="/dashboard/reports/leads"
                        @search="search = $event"
                    >
                        <template #filterItem>
                            <v-list-item class="flex justify-center pb-1">
                                <v-btn
                                    :ripple="false"
                                    outlined
                                    @click="
                                        $inertia.reload({
                                            data: {
                                                activeLeads: Number(
                                                    !activeLeads
                                                ),
                                            },
                                        })
                                    "
                                    class="flex soli-round soli-grey"
                                >
                                    <small class="mr-2"
                                        >View Current Leads</small
                                    >
                                    <v-icon
                                        :color="activeLeads ? 'accent' : null"
                                        >{{
                                            activeLeads
                                                ? "toggle_on"
                                                : "toggle_off"
                                        }}</v-icon
                                    ></v-btn
                                >
                            </v-list-item>
                        </template>
                    </ReportHeader>
                    <v-data-table
                        ref="table"
                        item-key="key"
                        :headers="headers"
                        :items="leads"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                        :groupBy="allLocations ? 'location' : null"
                        @current-items="collapse()"
                        @click:row="handleLeadSelection($event)"
                        class="cursor-pointer"
                    >
                        <template
                            v-slot:[`group.header`]="{
                                group,
                                items,
                                isOpen,
                                toggle,
                            }"
                        >
                            <th :colspan="headers.length">
                                <v-row
                                    no-gutters
                                    class="flex justify-start align-center pa-2"
                                >
                                    <v-icon @click="toggle" class="mr-3"
                                        >{{ isOpen ? "remove" : "add" }}
                                    </v-icon>
                                    <v-col>
                                        <div
                                            class="soli-grey text-subtitle-2 font-weight-bold"
                                        >
                                            {{ group }}
                                        </div>
                                        <div class="soli-grey text-small">
                                            • {{ items.length }} Lead(s)
                                        </div>
                                        <div class="soli-grey text-small">
                                            •
                                            {{
                                                `${
                                                    meta.find(
                                                        (e) =>
                                                            e.location == group
                                                    )?.conversion
                                                } Conversion`
                                            }}
                                        </div>
                                    </v-col>
                                </v-row>
                            </th>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                            <div class="d-flex align-center py-2 soli-grey">
                                <div>
                                    <Link
                                        v-if="item.user_id"
                                        @click.stop
                                        :href="`/profile/${item.user_id}/account`"
                                    >
                                        <v-list-item-title>
                                            {{ item.name }}
                                        </v-list-item-title>
                                    </Link>
                                    <v-list-item-title v-else>
                                        {{ item.name }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle v-if="item.email">
                                        {{ item.email }}
                                        <Clipboard
                                            :text="item.email"
                                            label="Copy Email"
                                            x-small
                                        />
                                    </v-list-item-subtitle>
                                </div>
                            </div>
                        </template>

                        <template v-slot:[`item.status.value`]="{ item }">
                            <v-chip
                                small
                                :color="item.status?.color ?? 'dark'"
                                class="font-bold text-capitalize"
                                >{{ item.status.value }}</v-chip
                            >
                        </template>

                        <template v-slot:[`item.workflow`]="{ item }">
                            <div
                                v-if="item.workflow"
                                class="flex flex-col gap-1"
                                style="max-width: 120px !important"
                            >
                                <div
                                    class="caption soli-grey whitespace-nowrap text-ellipsis overflow-hidden"
                                >
                                    {{ item.workflow.name }}
                                </div>
                                <v-progress-linear
                                    :value="item.workflow.progress?.stat"
                                    color="secondary"
                                    height="6"
                                    rounded
                                />
                            </div>
                        </template>

                        <template v-slot:[`item.resume`]="{ item }">
                            <Clipboard
                                v-if="item.resume"
                                :text="item.resume"
                                label="Copy link"
                                x-small
                            />
                        </template>
                    </v-data-table>

                    <!--<template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="ma-3">
                            <div class="ma-3">test</div>
                        </td></template
                    >-->
                </v-container>
            </v-card>
        </v-col>
        <!--<SoliResponsiveDialog
            v-if="showLeadDetails"
            @reset="showLeadDetails = null"
            :title="showLeadDetails.info.name"
            ><template #body>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Email:</b>&nbsp{{ showLeadDetails.info.email }}
                </v-list-item>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Phone:</b>&nbsp{{ showLeadDetails.info.phone }}
                </v-list-item>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Where:</b>&nbsp{{ showLeadDetails.where }}
                </v-list-item>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Instrument:</b>&nbsp{{ showLeadDetails.instrument }}
                </v-list-item>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Program:</b>&nbsp{{ showLeadDetails.program }}
                </v-list-item>
            </template></SoliResponsiveDialog
        >-->
        <ManageLead
            v-if="manageLead"
            :leadId="selection"
            @reset="closeManageLead()"
            @success="[($refs.layout.showMessage = true), closeManageLead()]"
            :errors="$page.props.errors"
        />
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";
import Stats from "../../Components/Reports/Stats.vue";
import Clipboard from "../../Components/Clipboard.vue";
import ManageLead from "../../Components/Guest/ManageLead.vue";
import CRMDrawer from "../../Layouts/CRMDrawer.vue";
import { ref } from "vue";
import { props } from "vuetrend";
//import CRMDrawer from "../../Components/CRM/CRMDrawer.vue";

export default {
    /*layout: (h, page) => {
        if (!page.data.props.crmClient?.id) return page;
        return h(CRMDrawer, { props: { ...page.data.props } }, [page]);
    },*/
    inject: ["getCrmClient"],
    layout: CRMDrawer,
    props: {
        errors: {
            type: Object,
            default: () => ({}),
        },
        leads: {
            type: Array,
            default: () => [],
        },
        meta: {
            type: Array,
            default: () => [],
        },
        selectedLocation: {
            type: Object,
            default: () => {},
        },
        allLocations: {
            type: Boolean,
            default: false,
        },
        dateRange: {
            type: Array,
            default: () => [],
        },
        totalConversion: {
            type: String,
            default: null,
        },
        activeLeads: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        AppLayout,
        Link,
        ReportHeader,
        Stats,
        Clipboard,
        ManageLead,
        //CRMDrawer,
    },
    data() {
        return {
            //showCRMDrawer: true,
            search: "",
            manageLead: false,
            selection: null,
            showMessage: false,
            expanded: [],
            headers: [
                {
                    text: "Lead",
                    align: "start",
                    sortable: true,
                    value: "name",
                },
                {
                    text: "Status",
                    align: "start",
                    sortable: true,
                    value: "status.value",
                },
                {
                    text: "Automation",
                    align: "start",
                    sortable: true,
                    value: "workflow",
                },
                {
                    text: "Children",
                    align: "start",
                    sortable: true,
                    value: "children",
                    width: "140px",
                },
                {
                    text: "Instruments",
                    align: "start",
                    sortable: true,
                    value: "instruments",
                    width: "140px",
                },
                {
                    text: "Programs",
                    align: "start",
                    sortable: true,
                    value: "programs",
                    width: "140px",
                },

                {
                    text: "Source",
                    align: "start",
                    sortable: true,
                    value: "source",
                    width: "120px",
                },
                {
                    text: "Promo",
                    align: "start",
                    sortable: true,
                    value: "promo",
                },
                {
                    text: "Campaign",
                    align: "start",
                    sortable: true,
                    value: "campaign_name",
                },
                {
                    text: "Date Received",
                    align: "start",
                    sortable: true,
                    value: "date",
                },
                {
                    text: "Resume Link",
                    align: "center",
                    sortable: false,
                    value: "resume",
                },
            ],
            showLeadDetails: null,
        };
    },
    computed: {
        stats() {
            return [
                {
                    title: "Leads",
                    data: this.leads.length,
                    color: "accent",
                    icon: "waving_hand",
                },
                {
                    title: "Conversion",
                    data: this.totalConversion,
                    color: "soli-status-green",
                    icon: "show_chart",
                },
            ];
        },
    },
    methods: {
        handleLeadSelection(lead) {
            console.log(lead.id);
            this.selection = lead.id;

            if (this.$page.props.auth.user.selected_location.crm_enabled) {
                this.getCrmClient(lead);
            } else {
                this.manageLead = true;
            }
        },
        collapse() {
            if (!this.allLocations) return;
            this.$nextTick(() => {
                let obj = this.$refs.table.openCache;
                Object.keys(obj).forEach((e) => (obj[e] = false));
            });
        },
        closeManageLead() {
            this.closeModal(() => {
                this.manageLead = false;
                this.selection = null;
            });
        },
    },
};
</script>
